





































































































































	import { Component, Vue, Prop } from 'vue-property-decorator';
	import { VHover, VListItem } from 'vuetify/lib'
	import { mapState, mapMutations, mapActions } from 'vuex'
	import { TranslateResult } from 'vue-i18n';
	import LocalePicker from '@/components/dashboard/shared/components/LocalePicker.vue';

	@Component({ 
		name: "DashboardCoreAppBar",
		components: {
			LocalePicker,
			AppBarItem: {
				render (h: any) {
					return h(VHover, {
						scopedSlots: {
							default: ({ hover }: any ) => {
								return h(VListItem, {
									attrs: this.$attrs,
									class: {
										'black--text': !hover,
										'white--text secondary elevation-12': hover,
									},
									props: {
										activeClass: '',
										dark: hover,
										link: true,
										dense: true,
										...this.$attrs,
									},
								}, this.$slots.default)
							},
						},
					})
				},
			},
		},

		computed: {
			...mapState('drawer', ['showDrawer']),
		},
		methods: {
			...mapActions({
				setDrawer: 'drawer/setDrawer'
			})
		}
	})
	export default class AppBar extends Vue {
		
		@Prop({ type: Boolean, default: false })
		public value: any;

		public showDrawer!: boolean;
		public setDrawer!: any;

		public notifications: any = []

		public profile: any[] = [
			{ title: 'Profile' },
			{ title: 'Settings' },
			{ divider: true },
			{ title: 'Log Out' },
		]

		get routeName(): TranslateResult {
			return this.$t(this.$route.name || '');
		}

		public async logout() {
			await this.$store.dispatch('auth/logout');
            this.$toast.info('You are logged out.');
            this.$router.push({ name: 'login' });
        } 
	}
